import $ from 'jquery';
import pubsub from './pubsub.js';
import transitionend from './transitionend';

let $header = $('.layout-header');
let $logo = $header.find('.layout-header__logo');
let $mainHeaderNav = $header.find('.layout-header__menu');

const initScroll = function() {

    let isFloat = false;

    pubsub.on('page.scroll', function(st) {
        if(st > 0) {
            if(!isFloat)
            {
                isFloat = true;
                $header.addClass('_float');
            }
        }
        else if(isFloat) {
            isFloat = false
            $header.removeClass('_float')
        }
    })
}

const initBurger = function() {
    let isBusy = false;

    const burgerActiveClass = '_active';
    const menuOpenClass = '_open';


    $('.js-trigger-menu').on('click', function(e) {
        let $this = $(this);
        let isActive = $this.hasClass(burgerActiveClass);

        e.preventDefault();

        if($(window).width() > 1023) {
            return false;
        }

        if(isBusy) {
            return;
        }
        isBusy = true;

        $mainHeaderNav.close = function() {
            if(isActive) {
                $mainHeaderNav.one(transitionend, function() {
                    $mainHeaderNav.css({'display': 'none'});
                    // назад помещает меню после лого
                    $logo.after($mainHeaderNav);
                    isBusy = false;
                });
            }
            $this.removeClass(burgerActiveClass)
            $mainHeaderNav.removeClass(menuOpenClass);
        };

        if(isActive) {
            $mainHeaderNav.close();
        }
        else {
            // фикс для ios12, из за того что .layout-header
            // в позиции fixed, был баг и меню зарегается и не видно его
            $mainHeaderNav.appendTo('body');

            $mainHeaderNav
                .css({'display': 'block'})
                .one(transitionend, function() {
                    document.body.style.position = 'fixed';

                    isBusy = false;
                });

            setTimeout(function() {

                $this.addClass(burgerActiveClass)
                $mainHeaderNav.addClass(menuOpenClass);

            }, 150);
        }
    });

    $('.js-trigger-filter').on('click', function() {
        $('.js-filter-pane').toggleClass('_opened');
    });
}

// Т.к. меню использует popup, то в мобильной версии при нажатии на иконку конверта нам надо показать popup поверх popup-а,
// чтобы этого не делать закрываем меню для мобильной версии
const initEmailFormHack = function() {
    $('.button__email').on('click', function(e) {
        if ($(window).width() < 1024 && $mainHeaderNav.close) {
            $mainHeaderNav.close();
        }
    });
}

const init = function()
{
    initScroll();
    initBurger();
    initEmailFormHack();
}

export default init;
